import { render, staticRenderFns } from "./RestrictFeatureModal.vue?vue&type=template&id=ab38037e&scoped=true"
import script from "./RestrictFeatureModal.vue?vue&type=script&lang=js"
export * from "./RestrictFeatureModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab38037e",
  null
  
)

export default component.exports